import { TrackingCategoryItem } from '~shared/modules/shopping-cart-global/models';

export const getCategoryNameHelper = (category: string | TrackingCategoryItem) => {
  if (typeof category === 'object') {
    return category.name;
  }

  return category;
}
